import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "reports/member-bill-report",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const memberBillReport = require("./MemberBillReport").default;
          cb(null, memberBillReport);
        },
        "FraudReport"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/MemberBillReport/index.js